<script>
import {BTable} from 'bootstrap-vue';
export default {
  components: {BTable},
  props: {
    items: {
      type: Function,
      default: () => ({totalCount: 0, data: []})
    },
    fields: {
      type: Array,
      default: () => []
    },
    perPage: {
      type: Number,
      default: 5
    },
    currentPage: {
      type: Number,
      default: 1
    },
    responsive: {
      type: Boolean,
      default: true
    },
    busy: {
      type: Boolean,
      default: false
    },
    stickyHeader: {
      type: Boolean,
      default: true
    },
    showEmpty: {
      type: Boolean,
      default: true
    },
    emptyText: {
      type: String,
      default: 'No Data'
    },
    emptyFilteredText: {
      type: String,
      default: 'No Data'
    }
  },
  render(h) {
    return h('b-table', {
      props: Object.assign(this.$attrs, this.$props),
      slots: this.$parent.$slots,
      scopedSlots: {...this.$scopedSlots, ...this.$parent.$scopedSlots}
    });
  }
};
</script>
